import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class OfflineBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.offline;
    }
}
export default OfflineBehavior;
